import { get, post } from '.';

export function FindFortePostLead(id, options = {}) {
	return get<any>("/app/api/forte_post_leads/" + (id || 0).toString(), options);
}

export function PostToForteCrm(options = {}) {
	return post<any>("/app/api/post_to_forte_crm", options);
}
